module.exports = __webpack_public_path__ + "ee9e79f6ab177986bc903a2a96c2603e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-9.png
// module id = 1809
// module chunks = 0